import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PercentagePipe } from '../Modules/idms/components/project-manager/components/projectoverview/percentage.pipe';
import { CustomDateFormatPipe, CustomDateTimeFormatPipe } from '../Modules/idms/services/date-format.service';

@NgModule({
    declarations: [PercentagePipe, CustomDateFormatPipe, CustomDateTimeFormatPipe],
    imports: [CommonModule],
    exports: [PercentagePipe, CustomDateFormatPipe, CustomDateTimeFormatPipe],
})
export class SharedPipeModule {}
